import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m32.708 31.293 12 12c.942.943-.472 2.357-1.415 1.414l-12-12A16.937 16.937 0 0 1 20 37c-9.39 0-17-7.61-17-17S10.61 3 20 3s17 7.61 17 17c0 4.335-1.622 8.29-4.292 11.293ZM5 20c0 8.285 6.715 15 15 15s15-6.715 15-15c0-8.286-6.715-15-15-15-8.286 0-15 6.715-15 15Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSearchOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SearchOutlined_default = SvgSearchOutlined;

export { SearchOutlined_default as default };
